import { makeStyles } from "@material-ui/core/styles";
import { alpha } from "@material-ui/core";
import { Colors, FONT_WEIGHT } from "../../helpers/theme";

const useStyles = makeStyles((theme) => ({

    MyGainspages: {
     
        "& .mobielViewMain": {  //mobile part style 
          background: Colors.white,
          border: `1px solid ${alpha(Colors.darkWhite, 0.1)}`,
          boxShadow: `0px 7px 41px ${alpha(Colors.black, 0.04)}`,
    
          borderRadius: "15px 15px 15px 15px",
        },
        "& .mobileContent": {
          background: ` ${alpha(Colors.aliceblue, 0.4)}`,
          borderRadius: " 6px",
        },
    
        "& .textColor": {
          color: Colors.greySlate,
        },
        "& .mobile-btn-width": {
          width: "50%",
          "&:first-child": {
            marginRight: "12px",
          },
        },
        "& .loadingBtn": {
          backgroundColor: ` ${alpha(Colors.loadingBlue, 0.2)}`,
          color: Colors.black,
          fontWeight: FONT_WEIGHT.bold,
          border: "0px",
        },
        "& .m-class": {
          marginRight: "5px",
        },
        "& .select-gains-status-dropdown":{
            width:"30%",
            "& .MuiSelect-outlined.MuiSelect-outlined":{
                color:Colors.greySlate
            },
            [theme.breakpoints.down("md")]: {
              width:"100%",
            },
            
        },
        "& .menu-paper-stake": {
          overflowY: 'hidden', /* Prevents vertical scrolling */
          maxHeight: 'none !important', /* Adjust height as needed */
        },
        "& .search-input":{
            '& .MuiOutlinedInput-input':{
                paddingTop:theme.spacing(1.9),
                paddingBottom:theme.spacing(1.9),
                paddingRight:theme.spacing(1.9),
              
            },
            "& .MuiOutlinedInput-adornedStart":{
                paddingLeft:theme.spacing(2.5)
            }
        },
        "& .res-button":{
            [theme.breakpoints.down("md")]: {
               minWidth:"95%"
                
              },
        },
        "& h2": {
          [theme.breakpoints.down("sm")]: {
            fontSize: theme.typography.body1.fontSize,
            "& span": {
              fontSize: theme.typography.body1.fontSize,
            },
          },
        },
        "& .MuiButton-label": {
          fontSize: "12px",
        },
      },
      stakeButton: {
        color: Colors.white,
        background: Colors.greenDark,
        "& .MuiButton-label": {
          fontSize: "1rem",
        },
      },
      buyButton: {
        backgroundColor: "transparent",
        color:Colors.greenDark,
        border:`1px solid rgba(17, 48, 45, 0.2)`,
        "& .MuiButton-label": {
          fontSize: "1rem",
        },
      },
      gainshead:{
         "& .MuiTableBody-root": {
            display: "block",
          },
          "& .MuiTableRow-root": {
            borderBottom: "1px solid rgba(76, 100, 97, 0.1)",
            verticalAlign: "baseline",
            width: "100%",
          //   display: "inherit",
            padding: "0px",
          },
          "& .MuiTypography-body1": {
            color: Colors.greySlate,
          },
          "& .MuiTableCell-root": {
            "&:first-child": {
              width: "15%",
            },
            "&:nth-child(2)": {
              width: "15%",
            },
            "&:nth-child(3)": {
              width: "15%",
            },
            "&:nth-child(4)": {
              width: "15%",
            },
            "&:nth-child(5)": {
              width: "10%",
            },
            "&:nth-child(6)": {
              width: "30%",
            },
          },
        },
      firsttable:{
        "&  .MuiTableRow-root":{
          width : '100%',
          boxShadow:'none',
          minHeight: "80px"
        },
      }

}))
export default useStyles;